import { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import redirectURL from "../redirectURL";
import SweetAlert from "react-bootstrap-sweetalert";


const ForceClosureModal = (props) => {

    const [modal, setModal] = useState(false)
    const [secondaryOptions, setSecondaryOptions] = useState([])
    const [primary, setPrimary] = useState('')
    const secondaryRef = useRef('')
    const secondaryTextBoxRef = useRef('')

    const closeModal = () => {
        setModal(false)
    }

    const handleClick = () => {
        setModal(true);
    }
    const submitHandler = (e) => {
        e.preventDefault()
        const consignemnt = props?.data;
        const consignment_code = consignemnt.consignment_code;
        const consignee_code = consignemnt.consignee_code;
        const truck_no = consignemnt.truck_no;
        const email = props?.user?.email;
        const reqdata = {
            dept_code: "SNDG",
            consignment_code: consignment_code,
            consignee_code: consignee_code,
            truck_no: truck_no,
            email: email,
            primary: primary?.value,
        }
        if (primary?.value == "Other")
            reqdata["secondary"] = secondaryTextBoxRef.current.value
        else
            reqdata["secondary"] = secondaryRef.current.getValue()[0]?.value
        redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
            .then((response) => {
                if (response.data.status == 'success') {
                    setSecondaryOptions([])
                    setPrimary('')
                    if (primary?.value == "Other")
                        secondaryTextBoxRef.current.value = ""
                    else
                        secondaryRef.current.setValue('')
                    setModal(false)
                    props?.setShow(true)
                    props?.setTitle(response.data.message)
                    props?.setType("success")
                    props?.loadData()
                }
                else {
                    props?.setShow(true)
                    props?.setTitle("Failed to Force Close")
                    props?.setType("danger")
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }

    if (props?.data?.status > 3) {
        return (<></>)
    }
    else {
        return (
            <>
                <Modal
                    onHide={closeModal}
                    dialogClassName="forceclose-modal"
                    show={modal}
                    centered>
                    <Modal.Header>
                        <Modal.Title>Force Close</Modal.Title>
                        <div className="btn-box d-flex gap-3">
                            <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="view-task">
                        <form onSubmit={submitHandler}>
                            <div className='container'>
                                <div className='row'>
                                    <div className="form-group col-xl-12 col-lg-12">
                                        <label style={{ display: "block", marginBottom: "5px" }}>
                                            <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Primary Reason
                                        </label>
                                        <Select
                                            value={primary}
                                            className="border-radius-0"
                                            isMulti={false}
                                            style={{ borderRadius: "0px" }}
                                            onChange={e => { setSecondaryOptions(props?.forceClosureReason?.reasonMap.get(e.value)); setPrimary(e); secondaryRef.current.setValue('') }}
                                            options={props?.forceClosureReason?.mainReason ?? []}
                                            required
                                        />
                                    </div>
                                    {
                                        primary?.value == "Other" ?
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label style={{ display: "block", marginBottom: "5px" }}>
                                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Secondary Reason
                                                </label>
                                                <textarea
                                                    ref={secondaryTextBoxRef}
                                                    rows={4}
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    required
                                                />
                                            </div> :
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label style={{ display: "block", marginBottom: "5px" }}>
                                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Secondary Reason
                                                </label>
                                                <Select
                                                    ref={secondaryRef}
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    style={{ borderRadius: "0px" }}
                                                    options={secondaryOptions}
                                                    required
                                                />
                                            </div>
                                    }
                                    <div className="form-group pt-4 col-xl-12 col-lg-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <button type='submit' className='primary-button'>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <a onClick={handleClick} title="Force Close"><button class="btn btn-danger custom-btn f12 label label-success">Force Close</button></a>
            </>
        )
    }
}
export default ForceClosureModal